import { render, staticRenderFns } from "./livePage.vue?vue&type=template&id=f843947e&scoped=true&"
import script from "./livePage.vue?vue&type=script&lang=js&"
export * from "./livePage.vue?vue&type=script&lang=js&"
import style0 from "./livePage.vue?vue&type=style&index=0&id=f843947e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f843947e",
  null
  
)

export default component.exports